module.exports = __webpack_public_path__ + "static/media/life-loader-green.15f8c6ea.gif";